var _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9475 -0.3196 0.3196 0.9475 -67.2231 78.8269)",
    style: {
      fill: "#F5F5FF"
    },
    cx: 206.549,
    cy: 244.221,
    rx: 142.424,
    ry: 160.232
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DFDFEB"
    },
    cx: 349.605,
    cy: 437.787,
    rx: 60.92,
    ry: 11.298
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3DDF7"
    },
    d: "M287.494,313.87H58.911c-5.61,0-10.158-4.548-10.158-10.158V160.014 c0-5.61,4.548-10.158,10.158-10.158h228.583c5.61,0,10.158,4.548,10.158,10.158v143.698 C297.652,309.322,293.104,313.87,287.494,313.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7584F1"
    },
    d: "M287.494,149.856H58.911c-5.61,0-10.158,4.548-10.158,10.158v9.984h248.898v-9.984 C297.652,154.404,293.104,149.856,287.494,149.856z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 256.366,
    cy: 160.247,
    r: 3.597
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 269.815,
    cy: 160.247,
    r: 3.597
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 283.265,
    cy: 160.247,
    r: 3.597
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7584F1"
    },
    d: "M150.813,200.125c-2.837,0-5.583-1.895-7.761-3.713l-2.652-2.213 c-1.64-1.369-3.589-2.102-5.586-2.102h-22.625c-2.053,0-3.717,1.664-3.717,3.717v4.311v79.022c0,2.756,2.234,4.989,4.989,4.989 h114.208c2.756,0,4.989-2.234,4.989-4.989v-74.032c0-2.756-2.234-4.989-4.989-4.989H150.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    d: "M223.563,216.111h-32.308c-1.44,0-2.608-1.168-2.608-2.608l0,0 c0-1.44,1.168-2.608,2.608-2.608h32.308c1.44,0,2.608,1.168,2.608,2.608l0,0C226.171,214.944,225.003,216.111,223.563,216.111z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M416.122,193.9c0,0,5.736,13.49,6.476,17.404c2.267,11.98,13.033,44.926,16.675,49.055 c0,0,6.8,0.729,10.199-1.214c0,0-8.5-53.912-12.142-61.197c-3.643-7.285-6.071-19.185-6.071-19.185L416.122,193.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M448.643,257.27c-3.761-3.129-11.35-1.271-12.673,3.439c-1.077,3.834-1.115,5.994-1.213,6.648 c-0.191,1.279-4.845,9.195-3.953,10.819c0.645,1.176,3.936-2.52,5.583-5.114c0.339-0.534,1.158-0.33,1.214,0.3 c0.312,3.522,1.004,10.567,1.611,11.443c0.813,1.173,3.77,6.141,4.647,5.603c0.877-0.539-0.107-3.998-0.877-6.313 c-0.77-2.315,0.178-7.466,0.178-7.466s3.905,11.755,5.559,13.878c2.464,3.162,3.284-1.999,3.284-1.999 c1.478,1.617,2.914-2.232,2.658-3.441c-0.505-2.389-4.206-10.852-3.551-10.542c0.655,0.31,4.83,9.25,6.725,9.511 c1.895,0.262,0.977-2.965-0.086-5.101c-1.063-2.135-3.942-8.283-3.942-8.283s-0.964-5.823-4.542-12.08 C449.235,258.522,448.687,257.307,448.643,257.27z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 451.925,
    y1: 288.224,
    x2: 446.798,
    y2: 276.303
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "413.418,171.436 359.745,169.244 359.745,90.049 387.996,85.97  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M387.158,85.297 c0,0,10.489,24.656,19.479,57.893"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M292.214,183.714c0,0,12.629,5.613,41.922-16.488l-12.454-13.857L292.214,183.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EC68A"
    },
    d: "M384.214,127.936c0.534-0.093,3.816,2.98,4.397,3.335c5.588,3.413,10.221,3.909,16.528,5.108 c12.44,2.365,21.211,22.194,22.476,26.336c1.495,4.895,4.09,13.313,5.585,18.208c0,0-2.452,13.622-18.203,13.316l-7.893-16.839 c0,0-8.946,20.171-9.472,21.75c-0.526,1.579,5.438,21.224,5.438,21.224s-47.008,18.067-74.371,8.332 c0,0,9.281-35.462,6.787-36.613c-2.361-1.09-7.265-5.358-1.35-24.866c0,0-9.91-5.788-12.278-21.049 c0,0,12.892-11.927,21.048-12.191C351.061,133.724,384.201,127.938,384.214,127.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.481,141.486c0,0,3.42,9.077,13.813,3.947c8.561-4.226,11.403-11.118,12.141-13.421 c-3.572-2.039-6.222-4.076-6.222-4.076s-14.568,2.543-26.766,4.335C356.787,133.64,350.898,146.47,364.481,141.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M383.293,110.966l0.921,16.97c0,0-7.893,11.971-17.365,10.656l-1.842-10.787L383.293,110.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M367.254,307.55l5.642,71.039l1.231,46.393c0,0,10.245,6.626,15.524-3.082 c0,0,9.468-48.149,8.405-64.702c-1.063-16.552,0.804-36.037,0.804-36.037L367.254,307.55z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.186,417.879c0,0-28.935,24.907-26.331,24.907c2.604,0,14.902-1.754,22.859-3.683 c7.957-1.929,11.14-7.016,11.14-7.016l0.579,4.911l5.498-0.702c0,0,6.221-13.155,1.881-20.522 C338.471,408.407,327.186,417.879,327.186,417.879z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "331.237,433.315 335.433,436.998 337.458,430.771 334.203,429.982  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.089,418.844c0,0-10.808,32.342-7.161,32.757c6.944,0.789,15.372-6.885,17.976-11.796 c2.604-4.911,2.315-12.629,2.315-12.629l-2.46,5.788h5.064c0,0,2.749-2.631,0.579-15.26 C390.402,417.703,374.089,433.709,374.089,418.844z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M329.356,305.27l-2.17,112.609c0,0,9.983,6.841,15.625-2.105c0,0,11.285-45.254,10.851-61.041 c-0.434-15.786,2.17-34.204,2.17-34.204L329.356,305.27z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.434,207.394c0,0,12.629,23.153,66.829,3.157c0,0,21.048,54.726,4.736,115.767c0,0-46.307,21.575-90.508-4.21 C314.491,322.108,321.858,246.334,333.434,207.394z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M334.136,130.041c0,0-40.08,28.24-43.062,33.151c-2.982,4.911-9.209,16.137-0.439,20.347 s43.588-34.116,52.007-47.096L334.136,130.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M298.003,182.136 c0,0,12.498-6.797,27.407-23.811"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M336.212,192.546 c0,0,33.18,15.9,53.702-1.64"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 407.104,
    y1: 177.4,
    x2: 399.963,
    y2: 166.211
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 334.136,
    y1: 167.227,
    x2: 338.17,
    y2: 159.158
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M355.721,121.064c-2.254-0.215-4.401,2.147-5.26,1.878c-0.684-0.214-1.606-3.456-1.952-4.766 c1.302-7.606,0.408-13.507-1.375-11.926c-0.095,0.085-0.207,0.262-0.324,0.49c-0.263-2.413-0.948-3.62-1.876-2.797 c-0.254,0.225-0.615,1.069-0.938,1.943c-0.279-2.273-0.952-3.385-1.853-2.587c-0.444,0.393-1.208,2.663-1.539,3.693 c-0.178-0.217-0.439-0.309-0.769-0.419c-1.288-0.429-4.258,10.698-4.401,11.271c-0.143,0.573-3.292,13.024-3.292,13.024 c-1.145,4.508,7.853,6.577,10.501,5.576c2.648-1.002,8.677-7.508,8.677-7.508c-0.007-0.012-0.017-0.023-0.024-0.035 c0.208-0.301,0.512-0.76,0.936-1.45c0.912-1.485,5.528-5.206,5.635-5.528S357.975,121.278,355.721,121.064z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.868,121.922c0.107-0.322,0.107-0.644-2.147-0.859c-2.254-0.215-4.401,2.147-5.26,1.878 c-0.684-0.214-1.606-3.456-1.952-4.766c1.302-7.606,0.408-13.507-1.375-11.926c-0.095,0.085-0.207,0.262-0.324,0.49 c-0.263-2.413-0.948-3.62-1.876-2.797c-0.254,0.225-0.615,1.069-0.938,1.943c-0.131-1.063-0.35-1.859-0.636-2.338 c-0.294,7.765,0.566,19.538,7.459,25.919c0.312-0.327,0.502-0.531,0.502-0.531c-0.007-0.012-0.017-0.023-0.024-0.035 c0.208-0.301,0.512-0.76,0.936-1.45C353.145,125.966,357.761,122.244,357.868,121.922z"
  })), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M381.254,114.189l2.039-3.223l-18.286,16.839l1.395,8.171C373.995,134.735,377.55,122.467,381.254,114.189z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M346.315,95.132c0,0-5.408,30.74,12.426,36.949c17.835,6.209,24.108-23.125,24.146-33.408 c0.039-10.283-4.747-15.674-17.446-16.959C346.655,79.812,346.315,95.132,346.315,95.132z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M386.849,83.268c-3.649-5.279-9.009-8.183-22.449-7.939c-10.23,0.186-16.651,7.017-18.833,10.563 c-0.707,1.149-2.454,4.396,0.91,7.882c0,0,0.112-2.465,2.387-5.21c0,0,21.288,11.538,29.794,9.844l2.028,7.977 c0,0,2.878-4.084,5.835-5.405C386.521,100.98,390.498,88.548,386.849,83.268z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6F4C"
    },
    d: "M390.227,108.652c-1.385,4.013-4.774,6.505-7.57,5.566c-2.796-0.938-3.939-4.952-2.554-8.965 c1.385-4.013,4.774-6.505,7.57-5.566C390.468,100.625,391.612,104.639,390.227,108.652z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.953,108.317c-0.017,1.055-0.574,1.904-1.245,1.894c-0.671-0.009-1.202-0.873-1.185-1.928 c0.017-1.056,0.574-1.904,1.245-1.894C363.439,106.398,363.969,107.261,363.953,108.317z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M349.889,108.273c0.039,0.993-0.42,1.818-1.025,1.843c-0.606,0.025-1.129-0.759-1.168-1.752 c-0.039-0.993,0.42-1.818,1.025-1.843C349.326,106.495,349.849,107.28,349.889,108.273z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M368.492,100.242 c0,0-4.877,0.719-4.902-3.865"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M352.217,98.81 c0,0-1.501,4.161-4.958,1.471"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M363.692,125.333c0,0,2.006-6.359,6.688-2.335L363.692,125.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M387.603,104.909 c0,0-3.021-2.96-5.096,1.96c0,0,1.741,2.105,0.46,3.585c0,0,1.815,0.538,2.83-1.028"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M386.093,106.745 c0,0-0.105-1.13-1.265-2.487"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M351.727,112.201 c-0.651,0.724-0.835,1.626-0.595,2.629c0.237,0.991,1.188,1.645,2.192,1.69"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M384.871,114.221c0,1.508-1.222,2.73-2.73,2.73s-2.73-1.222-2.73-2.73 c0-1.508,1.222-2.73,2.73-2.73S384.871,112.714,384.871,114.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M339.047,134.601 c0,0,1.052,2.28,3.596,1.842"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M340.604,106.992 c0,0,1.907,1.014-1.184,11.933c0,0,1.908,6.907,1.381,8.222c-0.526,1.315-3.157,3.508-3.947,3.596"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M345.976,123.814 c0,0-2.631,2.982-2.719,7.104"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M343.995,105.886 c0,0,0.621,8.369-0.695,12.907"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFDFEB"
    },
    d: "M260.514,455.211c0,3.885-9.053,7.035-20.22,7.035c-11.167,0-20.22-3.15-20.22-7.035 c0-3.885,9.053-7.035,20.22-7.035C251.462,448.176,260.514,451.326,260.514,455.211z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M239.841,350.569c0,0-6.115,0.572-4.034-15.26c1.977-15.04,9.559-26.004,10.138-26.048 c0,0,10.904,15.641,4.069,29.205C243.18,352.03,239.841,350.569,239.841,350.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M289.89,327.68c0,0-14.006,16.787-48.095,28.614c0,0-0.21-4.475,11.579-15.306 C265.162,330.158,291.521,322.542,289.89,327.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M289.89,327.68 c0,0-26.707,4.192-48.095,28.614c0,0-2.101,2.671-2.362,8.417"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M189.383,360.174c0,0,14.006,16.787,48.095,28.614c0,0,0.21-4.475-11.579-15.306 C214.111,362.651,187.752,355.035,189.383,360.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M189.383,360.174 c0,0,26.707,4.192,48.095,28.614c0,0,2.101,2.671,2.362,8.417"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M208.302,394.539c0,0,9.316,7.616,29.532,1.52c0,0-0.261-3.896-7.822-7.508 C222.45,384.94,206.947,390.951,208.302,394.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M208.302,394.539 c0,0,15.408-9.081,29.532,1.52c0,0,1.41,1.272,2.044,6.024"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M286.289,354.49c0,0-9.787,26.34-43.877,38.166c0,0-1.174-14.868,10.614-25.699 C264.815,356.127,287.92,349.352,286.289,354.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M286.289,354.49 c0,0-24.875,5.318-43.877,38.166c0,0-2.181,3.949-2.442,9.695"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E9E6E"
    },
    d: "M234.006,358.642c0,0-2.867,4.662-14.162,3.21c-11.295-1.452-23.507-14.878-31.133-12.441 C188.711,349.411,207.466,342.688,234.006,358.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M241.873,422.615 c-2.797-23.384-3.986-51.511-0.712-81.881c0,0,0.435-8.056,4.784-31.473"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M191.042,348.805 c0,0,18.964-4.598,42.964,9.837c5.814,3.497,5.55,10.09,5.18,15.228"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545FAC"
    },
    d: "M218.155,412.943l6.576,40.481c0,2.481,7.015,4.491,15.668,4.491s15.669-2.011,15.669-4.491 l6.576-40.481H218.155z"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.399,
    cy: 412.944,
    rx: 22.244,
    ry: 4.491
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3DDF7"
    },
    d: "M264.859,50.713c17.001,0.463,31.067,14.08,32.045,31.059c0.575,9.984-3.294,19.069-9.805,25.478 c-0.962,0.947-1.409,2.297-1.184,3.628l2.445,14.47l-15.045-8.766c-0.857-0.499-1.867-0.683-2.839-0.486 c-3.678,0.742-7.575,0.878-11.591,0.27c-14.863-2.252-26.459-14.556-27.83-29.527C229.228,66.887,245.165,50.176,264.859,50.713z "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.031,98.473c-0.457,0-0.807-0.145-1.05-0.434c-0.244-0.289-0.365-0.692-0.365-1.21c0-0.487,0.129-0.883,0.388-1.187 c0.258-0.304,0.601-0.457,1.027-0.457c0.486,0,0.845,0.145,1.073,0.434c0.229,0.29,0.343,0.693,0.343,1.21 c0,0.457-0.122,0.845-0.366,1.165C263.837,98.313,263.488,98.473,263.031,98.473z M262.75,87.101 c-0.035-0.943-0.069-1.91-0.104-2.9c-0.035-0.989-0.061-1.979-0.078-2.969c-0.018-0.989-0.01-2.002,0.026-3.037V66.138h1.146 l0.052,12.057c0,1.035-0.009,2.048-0.026,3.037c-0.018,0.99-0.044,1.98-0.078,2.969c-0.036,0.99-0.07,1.957-0.105,2.9H262.75z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 132.677 250.9341)",
    style: {
      fontFamily: "'Lexend-Light'",
      fontSize: "18.1198px"
    }
  }, "No Data")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataImage);
export default __webpack_public_path__ + "static/media/no-data-image.703133eaded7bc1ce31ba2fd4283e6e1.svg";
export { ForwardRef as ReactComponent };